import TabPanel from "../../../../../components/common/TabPanel";
import { Fragment, useRef, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import BasicDetail from "./basicDetail";
import Resources from "./resources";
import Schedule from "./schedule";
import Preview from "./preview";
import Format from "./format";

function CreateWebinar() {
  const formRef = useRef();
  const [value, setValue] = useState("basics");
  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>
      <Tabs
        value={value}
        variant="scrollable"
        onChange={handleChange}
        sx={{ button: { fontFamily: "Poppins" } }}
      >
        <Tab label="Basics" value="basics" disabled />
        <Tab label="Schedule" value="schedule" disabled />
        <Tab label="Format & Access" value="format" disabled />
        <Tab label="Resources" value="resources" disabled />
        <Tab label="Preview & Submit" value="submission" disabled />
      </Tabs>

      <Box sx={{ pt: 3 }}>
        <TabPanel
          index={value}
          value="basics"
          children={<BasicDetail data={formRef} setValue={setValue} />}
        />
        <TabPanel
          index={value}
          value="schedule"
          children={<Schedule data={formRef} setValue={setValue} />}
        />
        <TabPanel
          index={value}
          value="format"
          children={<Format data={formRef} setValue={setValue} />}
        />
        <TabPanel
          index={value}
          value="resources"
          children={<Resources data={formRef} setValue={setValue} />}
        />
        <TabPanel
          index={value}
          value="submission"
          children={<Preview data={formRef} setValue={setValue} />}
        />
      </Box>
    </Fragment>
  );
}

export default CreateWebinar;
